import { Role } from "@ses-mams/api-contract";

import { Badge } from "~/components/ui/badge";
import { Stack } from "~/components/ui/stack";

type RolesListProps = {
  roles: Array<Role>;
  direction: "row" | "column";
  active?: boolean;
};

export const RolesList = ({ roles, direction, active }: RolesListProps) => (
  <Stack gap="small" direction={direction}>
    {roles.map((role, index) => (
      <Badge
        key={`${role}-${index}`}
        tone={active ? "positive" : "muted"}
        size="medium"
      >
        {role}
      </Badge>
    ))}
  </Stack>
);
